import {useTranslation} from 'react-i18next';
import {Center} from '~/components/Center';
import {Blogs} from '../../components/Blogs';
import {BlogPageType} from '../../services/GetBlogPageService';

export function SectionRelatedBlogs({data}: {data: BlogPageType}) {
  const blogs = data.page.relatedArticles;

  const {t} = useTranslation();

  if (!blogs.length) {
    return null;
  }

  return (
    <section className="pt-20 pb-32 bg-gray-100">
      <Center className="px-5 md:px-10 lg:px-30">
        <h1 className="mb-10 text-3xl font-bold uppercase sm:mb-16 sm:text-4xl">
          {t('pages:blog:footer.title')}
        </h1>

        <Blogs data={blogs} size="small" />
      </Center>
    </section>
  );
}
